<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :search="pesquisa"
    height="calc(100vh - 230px)"
    class="elevation-2 table-full-screen mx-1"
    :items-per-page="-1"
    fixed-header
    hide-default-footer
    :item-class="itemClass"
  >
    <template v-slot:top>
      <div class="d-flex mx-2 pt-2 mb-1 align-center">
        <p class="ma-0 mt-1 subtitle-1 font-weight-medium">
          <v-icon left>mdi-format-list-bulleted</v-icon>
          Pedidos de Separação
        </p>

        <v-spacer />

        <v-text-field
         v-model="pesquisa"
         label="Pesquisa"
         hide-details
         height="28"
         append-icon="mdi-magnify"
         class="mt-n1"
         style="max-width: 450px"
        />

        <EnviarEmailPedidosEmSeparacaoAtual />
      </div>
    </template>

    <template v-slot:item.filial_destino="{item}">
      {{ item.descricao_hub ? item.descricao_hub : item.filial_destino }}
    </template>

    <template v-slot:item.qtde_produtos="{item}">
      <div class="text-center" style="max-width: 70px">
        {{Helpers.formatarValor(item.qtde_produtos)}}
      </div>
    </template>

    <template v-slot:item.acoes="{item}">
      <div class="d-flex">
        <v-spacer />

        <incluir-pedido-loja-drp
          v-if="item.status === 'POR EXPORTAR'"
          :pedido="item"
          icon
          @pedido-exportado="getListaPedidosSeparacao()"
        />

        <ResultadoExportacaoProtheus v-else :pedido="item" />

        <dialog-status-exportacao-protheus
          v-model="item.dialogStatusProtheus"
          :item="item"
        >
          <template v-slot:activator>
            <v-btn icon @click="item.dialogStatusProtheus = true" title="Visualizar Status da Exportação para o Protheus">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
        </dialog-status-exportacao-protheus>

        <lista-produtos-do-pedido :pedido="item"/>
      </div>
    </template>

    <template v-slot:footer>
      <rodape-lista-de-pedidos v-if="existeItemsPorExportar" :items="items" />
    </template>
  </v-data-table>
</template>

<script>
import PedidoAPI from "../../../../api/drp/pedido";
import {mapGetters} from "vuex";
import ListaProdutosDoPedido from "./ListaProdutosDoPedido";
import DialogStatusExportacaoProtheus from "../../separacaoDeMercadorias/exportacaoProtheus/DialogStatusExportacaoProtheus";
import RodapeListaDePedidos from "./RodapeListaDePedidos";
import IncluirPedidoLojaDrp from "../../separacaoDeMercadorias/exportacaoProtheus/IncluirPedidoLojaDrp";
import ResultadoExportacaoProtheus from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/Protheus/ResultadoExportacaoProtheus.vue";
import EnviarEmailPedidosEmSeparacaoAtual from "@/components/drp/configDrpAutomatizado/WorkflowEmail/EnviarEmailPedidosEmSeparacaoAtual.vue";

export default {
  name: "ListaDePedidos",
  components: {
    EnviarEmailPedidosEmSeparacaoAtual,
    IncluirPedidoLojaDrp,
    RodapeListaDePedidos,
    DialogStatusExportacaoProtheus,
    ListaProdutosDoPedido,
    ResultadoExportacaoProtheus,
  },
  data: () => ({
    headers: [
      {text: 'id', value: 'idpedido'},
      {text: 'Separador', value: 'separador'},
      {text: 'Filial Origem', value: 'filial_origem'},
      {text: 'Filial Destino', value: 'filial_destino'},
      {text: 'Data Emissão', value: 'data_emissao'},
      {text: 'Status', value: 'status'},
      {text: 'Qtde. Itens', value: 'qtde_produtos'},
      {text: 'Ações', value: 'acoes', width: '100px'},
    ],
    items: [],
    pesquisa: ''
  }),
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras"
    }),
    existeItemsPorExportar() {
      return this.items.some(item => item.status === 'POR EXPORTAR')
    }
  },
  mounted() {
    this.getListaPedidosSeparacao();
  },
  methods: {
    itemClass(item) {
      return {
        'bg-red-50': item.status === 'POR EXPORTAR'
      }
    },
    getListaPedidosSeparacao() {
      this.$store.dispatch(
        "loading/addRequisicao",
        PedidoAPI.getPedidosSeparacaoRobo({idGrupo: this.grupoCompra})
          .then(response => {
            const {token, listaPedidos} = response.data;
            localStorage.token = token;
            this.items = listaPedidos.map(item => {
              item.dialogStatusProtheus = false;
              return item;
            });
          })
        .catch(() => this.Helpers.logout())
      );
    }
  }
}
</script>

<style scoped>
</style>
